module.exports = __webpack_public_path__ + "static/media/loc.5c6210ac.svg";